function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import pick from 'lodash/pick';
import { SelectTheme } from 'common/components/select/constants';
import { StepSelection } from 'common/report/funnels/models/types';
import { useTranslation } from 'common/i18n/hooks';
import { RowLabelType } from 'common/query-builder/query-entry-section/types';
import { SelectReact } from 'common/components/select';
import { RangeSelection } from './types';
import { generateStepRanges } from './util';
import styles from './index.module.styl';
export type Props = {
  selected?: StepSelection;
  numSteps?: number;
  rowLabelType?: RowLabelType;
  label?: string;
  theme?: SelectTheme;
  tooltip?: string;
  disableAllSteps?: boolean;
  disabled?: boolean;
  onSelect?: (ev: {
    detail: RangeSelection;
  }) => void;
};
export function StepRangeSelector(props: Props) {
  const i18n = useTranslation();
  const sections = [{
    items: generateStepRanges({
      entry: props.selected,
      steps: props.numSteps,
      rowLabelType: props.rowLabelType,
      disableAllSteps: props.disableAllSteps
    }).map(item => {
      var _item$tooltip;
      return _objectSpread(_objectSpread({}, item), {}, {
        label: typeof item.label === "string" ? item.label : item.label(i18n),
        tooltip: item.tooltip ? _objectSpread(_objectSpread({}, item.tooltip), {}, {
          text: typeof item.tooltip.text === "string" ? item.tooltip.text : (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text(i18n)
        }) : null
      });
    })
  }];
  const handleChange = ev => {
    var _props$onSelect;
    const item = pick(ev.detail.item.value, ["isEntireRange", "range"]);
    (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 || _props$onSelect.call(props, {
      detail: item
    });
  };
  return <div className={styles.container} data-sentry-component="StepRangeSelector" data-sentry-source-file="index.tsx">
      {props.label ? <div className={styles.label}>{props.label}</div> : null}
      <SelectReact className={styles.select} sections={sections} theme={props.theme} menuWidth={140} disabled={props.disabled} tooltip={props.tooltip && {
      text: props.tooltip
    }} onChange={handleChange} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx" />
    </div>;
}